import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { Nav, NavDropdown} from 'react-bootstrap';


function NavCoach(props) {
  const Navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const apiUrl = process.env.REACT_APP_API_URL;

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  }

  const handleLogout = async (event) => {
    event.preventDefault();
    try {
      const response = await axios.post(`${apiUrl}/deconnexion`, {}, { withCredentials: true });
      if (response.data.success) {
        Cookies.remove('token');
        Navigate('/connexion');
      } else {
        console.error('Erreur lors de la déconnexion');
      }
    } catch (error) {
      console.error('Erreur lors de la déconnexion');
    }
  };

  return (
    <>
      <button className="toggle-button" onClick={toggleSidebar}>
        ☰
      </button>
      {sidebarOpen? ( 
      <div className='sidebar-container' >
        <div className="sidebar">
          <div className="sidebar-header" >
            <img src={`${apiUrl}/image/equipe/${props.userData.user.donnée.results[0].logo}`} alt="Logo" className="logo_" /> 
          </div>
          <Nav className="flex-column">
            <Nav.Link href="/coach/accueil">Accueil</Nav.Link>
            <Nav.Link href="/coach/parametre">Paramètres</Nav.Link>
            <Nav.Link href="/coach/agenda">Agenda</Nav.Link>
            <Nav.Link href={`/coach/equipe/${props.userData.user.donnée.results[0].id_equipe}`}>Equipe</Nav.Link>
            <NavDropdown title="Tableau de bord" id="basic-nav-dropdown">
              <NavDropdown.Item href="/coach/tableau-de-bord">Accueil</NavDropdown.Item>
              <NavDropdown.Item href="/coach/tableau-de-bord/match">Match</NavDropdown.Item>
              <NavDropdown.Item href="/coach/tableau-de-bord/classement">Classement</NavDropdown.Item>
              <NavDropdown.Item href="/coach/tableau-de-bord/tournois">Tournois</NavDropdown.Item>
              <NavDropdown.Item href="/coach/tableau-de-bord/selection">Sélection</NavDropdown.Item>
              <NavDropdown.Item href="/coach/tableau-de-bord/arbitrage">Arbitrage</NavDropdown.Item>
          </NavDropdown>
            <Nav.Link href="/coach/post">Publications</Nav.Link>
            <Nav.Link href="/coach/messagerie">Messages</Nav.Link>
          </Nav>
          <div className="sidebar-footer">
            <div className="user-info">
              <div>{props.userData.user.donnée.results[0].nom_coach} {props.userData.user.donnée.results[0].prenom}</div>
              <div>{props.userData.user.donnée.results[0].nom_equipe} ({props.userData.user.donnée.results[0].categorie})</div>
            </div>
            <button className="logout-button" onClick={handleLogout}>Déconnexion</button>
          </div>
        </div>
      </div>
          ):(<></>)}
    </>
  );
}

export default NavCoach;
